import { FC } from "react";
import { useTranslation } from "react-i18next";

import { formatRebuildRouteDefaultActionHeading } from "@ryde/shared";

interface IRebuildRouteDropdownDefaultRebuildHeadingProps {
  hasProductionId?: boolean;
}

export const RebuildRouteDropdownDefaultRebuildHeading: FC<
  IRebuildRouteDropdownDefaultRebuildHeadingProps
> = ({ hasProductionId = false }) => {
  const { t } = useTranslation();

  return (
    <div className="rebuild-route-dropdown-default-rebuild-heading">
      {formatRebuildRouteDefaultActionHeading({ hasProductionId, t })}
    </div>
  );
};
